module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-47.df388cb3.png";